module.exports = __webpack_public_path__ + "onboarding-targets.86aaaed507b8a599a8fa76f238a05769.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/environments/empty/onboarding-targets.svg
// module id = 8176252575776974
// module chunks = 1